/**
 * Created by A665445 on 03/04/2017.
 */
import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../shared/login/login.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Principal } from '../../shared/auth/principal.service';
import { CampaignService } from '../../entities/campaign/campaign.service';
import { PropertiesService } from '../../entities/saisine/properties.service';
import { RegionService } from '../../admin/user-management/region.service';

@Component({
    selector: 'jhi-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.scss']
})
export class HeaderComponent implements OnInit {
    burgerBtnClicked: boolean;
    displayLinks: boolean;
    visibleGraph: boolean;
    selectableCampaigns: string[];
    selectedCampaign: string;
    initialized = false;

    constructor(private loginService: LoginService, private principal: Principal, private route: ActivatedRoute, private router: Router, public campaignService: CampaignService, private regionService: RegionService, public propertiesService: PropertiesService) { }

    ngOnInit() {
        this.displayLinks = true;
        this.burgerBtnClicked = false;

        this.principal.getAuthenticationState().subscribe((identity) => {
            if (identity === null) {
                this.displayLinks = true;
            } else {
                if (this.principal.hasSyncAuthority('ROLE_ADMIN')) {
                    this.selectableCampaigns = this.campaignService.getCampaignYears();
                } else {
                    this.selectableCampaigns = this.campaignService.getCampaignYears().filter(_ => _ <= this.campaignService.getCurrentCampaignYear());
                }
                this.selectedCampaign = this.campaignService.getDisplayedCampaign();
                if (this.principal.hasSyncAuthority('ROLE_INTERNAL')) {
                    this.displayLinks = false;
                } else {
                    this.displayLinks = true;
                }
                if (this.principal.hasSyncAuthority('ROLE_MINISTRY')) {
                    this.visibleGraph = ('true' === this.propertiesService.properties.visibleGraph);
                } else {
                    this.visibleGraph = false;
                }
            }
            this.initialized = true;
        });


        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const tree = this.router.parseUrl(this.router.url);
                if (tree.fragment) {
                    setTimeout(() => {
                        const element = document.querySelector('#' + tree.fragment) as HTMLElement;
                        if (element) {
                            element.focus();
                        }
                    }, 200);
                }
            }
        });
    }

    showMenu() {
        this.burgerBtnClicked = !this.burgerBtnClicked;
    }

    logout() {
        this.displayLinks = true;
        this.visibleGraph = false;
        this.loginService.logout();
        sessionStorage.clear();
        this.router.navigate(['/interne']);
    }

    hasAnyAuthority(authority: string): boolean {
        return this.principal.hasSyncAuthority(authority);
    }

    async changeSelectedCampaign() {
        if (this.initialized && this.selectedCampaign !== this.campaignService.getDisplayedCampaign()) {
            this.campaignService.setDisplayedCampaign(this.selectedCampaign);

            await this.regionService.getRegions({ 'campaign': this.campaignService.getDisplayedCampaign() }, true).toPromise();
            this.notifyPage();
        }
    }

    notifyPage() {
        if (this.campaignService.isUserViewingCurrentOrPreviousCampaign() && this.principal.hasAnySyncAuthority(['ROLE_ACADEMICRECTOR', 'ROLE_ACADEMICREGIONRECTOR', 'ROLE_MINISTRY'])) {
            if (this.router.url === '/saisines') {
                this.campaignService.notifyOther('saisines');
            } else {
                this.router.navigate(['/saisines']);
            }
        } else if (this.principal.hasSyncAuthority('ROLE_ADMIN')) {
            if (this.router.url === '/referentiel-masters') {
                this.campaignService.notifyOther('referentiel-masters');
            } else {
                this.router.navigate(['/referentiel-masters']);
            }
        } else if (this.principal.isSchoolProfile()) {
            if (this.router.url === '/propositions') {
                this.campaignService.notifyOther('propositions');
            } else {
                this.router.navigate(['/propositions']);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/header/header.component.ts